import React, { useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Container from 'common/components/UI/Container';
import Heading from 'common/components/Heading';
import GatsbyImage from 'common/components/GatsbyImage';
import {
  Section,
  ContentWrapper,
  FormContainer,
  Illustration,
  StyledForm,
  Input,
  TextArea,
  Button,
  HeadingWrapper
} from './contactForm.style';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [error, setError] = useState('');

  const data = useStaticQuery(graphql`
    query {
      illustration: file(
        relativePath: { eq: "image/saasMinimal2/contactBanner/contact_section.png" }
      ) {
        childImageSharp {
          gatsbyImageData(width: 1000, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
        }
      }
    }
  `);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError({ ...error, [e.target.name]: '' });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (!formData[key]) {
        newErrors[key] = 'This field is required';
      }
    });
    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
      return;
    }
    setError({});
    console.log('Form submitted:', formData);
  };

  return (
    <Section>
      <Container>
        <HeadingWrapper>
          <p>LET'S TALK</p>
          <Heading content="Send Us Your Feedback" />
          <p>We value your input! Please share your thoughts and suggestions to help us improve our services</p>
        </HeadingWrapper>
        <ContentWrapper>
          <Illustration>
            <GatsbyImage src={data.illustration?.childImageSharp?.gatsbyImageData || {}} alt="Illustration" />
          </Illustration>
          <FormContainer>
            <StyledForm onSubmit={handleSubmit}>
              <label htmlFor="name">Name</label>
              <Input id="name" type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} style={{ borderColor: error.name ? 'red' : '#ccc' }} />
              {error.name && <p style={{ color: 'red', fontSize: '12px' }}>{error.name}</p>}
              
              <label htmlFor="email">Email</label>
              <Input id="email" type="email" name="email" placeholder="Your Email" value={formData.email} onChange={handleChange} style={{ borderColor: error.email ? 'red' : '#ccc' }} />
              {error.email && <p style={{ color: 'red', fontSize: '12px' }}>{error.email}</p>}
              
              <label htmlFor="subject">Subject</label>
              <Input id="subject" type="text" name="subject" placeholder="Subject" value={formData.subject} onChange={handleChange} style={{ borderColor: error.subject ? 'red' : '#ccc' }} />
              {error.subject && <p style={{ color: 'red', fontSize: '12px' }}>{error.subject}</p>}
              
              <label htmlFor="message">Message</label>
              <TextArea id="message" name="message" placeholder="Your Message" rows="5" value={formData.message} onChange={handleChange} style={{ borderColor: error.message ? 'red' : '#ccc', resize: 'vertical' }} />
              {error.message && <p style={{ color: 'red', fontSize: '12px' }}>{error.message}</p>}
              
              <Button type="submit">Send Message</Button>
            </StyledForm>
          </FormContainer>
        </ContentWrapper>
      </Container>
    </Section>
  );
};

export default ContactForm;
